/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */
import * as com_amazon_coral_availability from "@amzn/coral_com-amazon-coral-availability";
import * as com_amazon_coral_service_bsf from "@amzn/coral_com-amazon-coral-service-bsf";
import * as com_amazon_coral_client from "@amzn/coral_com-amazon-coral-client";
import * as com_amazon_coral_service from "@amzn/coral_com-amazon-coral-service";
import * as com_amazon_trans_feedback_tcfa_model_v_1 from "@amzn/coral_com-amazon-trans-feedback-tcfa-model-v-1";
import { GetTermManualInput } from "./GetTermManualInput";
import { CLWSInvalidRequestException } from "./CLWSInvalidRequestException";
import { GetInlineHelpContentOutput } from "./GetInlineHelpContentOutput";
import { CLWSUnrecoverableException } from "./CLWSUnrecoverableException";
import { GetLogisticsPartyDetailsInput } from "./GetLogisticsPartyDetailsInput";
import { GetAuthorizedEntitiesInput } from "./GetAuthorizedEntitiesInput";
import { GetInlineHelpContentInput } from "./GetInlineHelpContentInput";
import { GetAuthorizedEntitiesOutput } from "./GetAuthorizedEntitiesOutput";
import { GetAuthorizedLogisticsPartiesInput } from "./GetAuthorizedLogisticsPartiesInput";
import { GetAuthorizedLogisticsPartiesOutput } from "./GetAuthorizedLogisticsPartiesOutput";
import { CLWSRecoverableException } from "./CLWSRecoverableException";
import { GetLogisticsPartyDetailsOutput } from "./GetLogisticsPartyDetailsOutput";
import { GetTermManualOutput } from "./GetTermManualOutput";
import * as com_amazon_coral_service_jms from "@amzn/coral_com-amazon-coral-service-jms";
import * as com_amazon_coral_validate from "@amzn/coral_com-amazon-coral-validate";
import * as com_amazon_coral_service_http from "@amzn/coral_com-amazon-coral-service-http";
import { CoralClient, CoralResponse, } from "@amzn/ihm-js-coral-client";
import { CoralClientHttpBindingInterceptor, CoralClientSerdesInterceptor, InterceptingHandler, } from "@amzn/ihm-js-coral-client";
import { throwError } from "rxjs";
import { map, catchError } from "rxjs/operators";
export const carrierLogisticsWebServerSerdesInterceptor = new CoralClientSerdesInterceptor({
    GetAuthorizedEntities: {
        deserializationFn: GetAuthorizedEntitiesOutput.fromJson,
        serializationFn: GetAuthorizedEntitiesInput.toJson,
        modelledExceptions: [
            CLWSRecoverableException,
            CLWSInvalidRequestException,
            CLWSUnrecoverableException,
        ],
    },
    GetAuthorizedLogisticsParties: {
        deserializationFn: GetAuthorizedLogisticsPartiesOutput.fromJson,
        serializationFn: GetAuthorizedLogisticsPartiesInput.toJson,
        modelledExceptions: [
            CLWSRecoverableException,
            CLWSInvalidRequestException,
            CLWSUnrecoverableException,
        ],
    },
    GetDisplayableFeedbackQuestionnaire: {
        deserializationFn: com_amazon_trans_feedback_tcfa_model_v_1
            .GetDisplayableFeedbackQuestionnaireResponse.fromJson,
        serializationFn: com_amazon_trans_feedback_tcfa_model_v_1
            .GetDisplayableFeedbackQuestionnaireRequest.toJson,
        modelledExceptions: [
            CLWSRecoverableException,
            CLWSInvalidRequestException,
            CLWSUnrecoverableException,
        ],
    },
    GetInlineHelpContent: {
        deserializationFn: GetInlineHelpContentOutput.fromJson,
        serializationFn: GetInlineHelpContentInput.toJson,
        modelledExceptions: [
            CLWSRecoverableException,
            CLWSInvalidRequestException,
            CLWSUnrecoverableException,
        ],
    },
    GetLogisticsPartyDetails: {
        deserializationFn: GetLogisticsPartyDetailsOutput.fromJson,
        serializationFn: GetLogisticsPartyDetailsInput.toJson,
        modelledExceptions: [
            CLWSRecoverableException,
            CLWSInvalidRequestException,
            CLWSUnrecoverableException,
        ],
    },
    GetTermManual: {
        deserializationFn: GetTermManualOutput.fromJson,
        serializationFn: GetTermManualInput.toJson,
        modelledExceptions: [
            CLWSRecoverableException,
            CLWSInvalidRequestException,
            CLWSUnrecoverableException,
        ],
    },
    SubmitFeedback: {
        serializationFn: com_amazon_trans_feedback_tcfa_model_v_1.SubmitFeedbackRequest.toJson,
        modelledExceptions: [
            CLWSRecoverableException,
            CLWSInvalidRequestException,
            CLWSUnrecoverableException,
        ],
    },
}, [
    com_amazon_coral_availability.BackOffException,
    com_amazon_coral_availability.ThrottlingException,
    com_amazon_coral_client.ClientUnavailableException,
    com_amazon_coral_client.HttpConnectionTimeoutException,
    com_amazon_coral_client.HttpFailureException,
    com_amazon_coral_client.HttpTimeoutException,
    com_amazon_coral_service_bsf.InvalidCodigoMessageException,
    com_amazon_coral_service_http.HeaderMisclassificationException,
    com_amazon_coral_service_http.HttpNotFoundException,
    com_amazon_coral_service_http.InvalidAuthSchemeException,
    com_amazon_coral_service_http.InvalidAuthSchemeParameterException,
    com_amazon_coral_service_http.InvalidMessageDigestException,
    com_amazon_coral_service_http.MissingAuthSchemeParameterException,
    com_amazon_coral_service_http.MissingMessageDigestException,
    com_amazon_coral_service_http.MissingRequiredHeaderException,
    com_amazon_coral_service_jms.MessageProcessingException,
    com_amazon_coral_service_jms.MessagePublishException,
    com_amazon_coral_service.AccessDeniedException,
    com_amazon_coral_service.DelegationException,
    com_amazon_coral_service.ExpiredTokenException,
    com_amazon_coral_service.IncompleteSignatureException,
    com_amazon_coral_service.InternalFailure,
    com_amazon_coral_service.InvalidAwsQueryStringException,
    com_amazon_coral_service.InvalidParameterCombinationException,
    com_amazon_coral_service.InvalidParameterValueException,
    com_amazon_coral_service.InvalidQueryParameterException,
    com_amazon_coral_service.InvalidQueryStringException,
    com_amazon_coral_service.InvalidSignatureException,
    com_amazon_coral_service.MalformedHttpRequestException,
    com_amazon_coral_service.MissingActionException,
    com_amazon_coral_service.MissingAuthenticationTokenException,
    com_amazon_coral_service.MissingRequiredParameterException,
    com_amazon_coral_service.NotAuthorizedException,
    com_amazon_coral_service.RequestAbortedException,
    com_amazon_coral_service.RequestEntityTooLargeException,
    com_amazon_coral_service.RequestExpiredException,
    com_amazon_coral_service.RequestTimeoutException,
    com_amazon_coral_service.SerializationException,
    com_amazon_coral_service.ServiceUnavailableException,
    com_amazon_coral_service.SubscriptionRequiredException,
    com_amazon_coral_service.TimeoutException,
    com_amazon_coral_service.TransmutationException,
    com_amazon_coral_service.UnknownOperationException,
    com_amazon_coral_service.UnrecognizedClientException,
    com_amazon_coral_service.UnsupportedMediaTypeException,
    com_amazon_coral_validate.ValidationException,
]);
export const carrierLogisticsWebServerHttpBindingInterceptor = new CoralClientHttpBindingInterceptor({
    GetAuthorizedEntities: {
        method: "POST",
        path: "/clws/entities/v1/get-authorized-entities",
    },
    GetAuthorizedLogisticsParties: {
        method: "POST",
        path: "/clws/logisticsParty/v1/get-authorized-logisticsParties",
    },
    GetDisplayableFeedbackQuestionnaire: {
        method: "GET",
        path: "/clws/feedback/v1/displayable-questionnaire/applications/{applicationId}/intents/{feedbackIntent}/",
        labelTransformations: {
            applicationId: "applicationId",
            feedbackIntent: "feedbackIntent",
        },
    },
    GetInlineHelpContent: {
        method: "POST",
        path: "/clws/content/v1/get-inline-help-content",
    },
    GetLogisticsPartyDetails: {
        method: "GET",
        path: "/clws/logisticsParty/v1/get-logisticsParty-details",
    },
    GetTermManual: {
        method: "POST",
        path: "/clws/content/v1/download-manual",
    },
    SubmitFeedback: {
        method: "POST",
        path: "/clws/feedback/v1/submit/applications/{applicationId}/intents/{feedbackIntent}?sif_profile={sifProfileId}",
        labelTransformations: {
            sifProfileId: "sifProfileId",
            applicationId: "applicationId",
            feedbackIntent: "feedbackIntent",
        },
    },
});
/**
 * <p>An example service, deployed with the Octane Service creator,
 * which will echo the string<\/p>
 **/
export class CarrierLogisticsWebServer extends CoralClient {
    constructor(config, handler) {
        const serdesHandler = new InterceptingHandler(handler, [
            carrierLogisticsWebServerSerdesInterceptor,
        ]);
        super(config, serdesHandler);
    }
    /**
     * <pre><code>Sync API responsible to give all the entities that user have permission to
     * These entities are returned at each PermissionLevel
     * <\/code><\/pre>
     **/
    getAuthorizedEntities(request) {
        return super.call("GetAuthorizedEntities", request).pipe(map(({ body }) => {
            if (!(body instanceof GetAuthorizedEntitiesOutput)) {
                throw new TypeError(`[CarrierLogisticsWebServer] Expected response body to be of type GetAuthorizedEntitiesOutput. Got ${body && body.constructor.name}`);
            }
            return body;
        }), catchError((error) => throwError(typeof error === "object" &&
            error !== null &&
            error.constructor.name === CoralResponse.name &&
            error.body !== undefined
            ? error.body
            : error)));
    }
    /**
     * <p>API responsible to give all the Lps user have ACCESS permission to,
     * This API solves the partner-picker use case<\/p>
     **/
    getAuthorizedLogisticsParties(request) {
        return super.call("GetAuthorizedLogisticsParties", request).pipe(map(({ body }) => {
            if (!(body instanceof GetAuthorizedLogisticsPartiesOutput)) {
                throw new TypeError(`[CarrierLogisticsWebServer] Expected response body to be of type GetAuthorizedLogisticsPartiesOutput. Got ${body && body.constructor.name}`);
            }
            return body;
        }), catchError((error) => throwError(typeof error === "object" &&
            error !== null &&
            error.constructor.name === CoralResponse.name &&
            error.body !== undefined
            ? error.body
            : error)));
    }
    /**
     * <p>API responsible for getting eligible questionnaire inorder to provide feedback<\/p>
     **/
    getDisplayableFeedbackQuestionnaire(request) {
        return super.call("GetDisplayableFeedbackQuestionnaire", request).pipe(map(({ body }) => {
            if (!(body instanceof
                com_amazon_trans_feedback_tcfa_model_v_1.GetDisplayableFeedbackQuestionnaireResponse)) {
                throw new TypeError(`[CarrierLogisticsWebServer] Expected response body to be of type com_amazon_trans_feedback_tcfa_model_v_1.GetDisplayableFeedbackQuestionnaireResponse. Got ${body && body.constructor.name}`);
            }
            return body;
        }), catchError((error) => throwError(typeof error === "object" &&
            error !== null &&
            error.constructor.name === CoralResponse.name &&
            error.body !== undefined
            ? error.body
            : error)));
    }
    /**
     * <p>API responsible for getting inline help content<\/p>
     **/
    getInlineHelpContent(request) {
        return super.call("GetInlineHelpContent", request).pipe(map(({ body }) => {
            if (!(body instanceof GetInlineHelpContentOutput)) {
                throw new TypeError(`[CarrierLogisticsWebServer] Expected response body to be of type GetInlineHelpContentOutput. Got ${body && body.constructor.name}`);
            }
            return body;
        }), catchError((error) => throwError(typeof error === "object" &&
            error !== null &&
            error.constructor.name === CoralResponse.name &&
            error.body !== undefined
            ? error.body
            : error)));
    }
    /**
     * <p>API responsible to give LogisticsPartyDetails for the given LpId<\/p>
     **/
    getLogisticsPartyDetails(request) {
        return super.call("GetLogisticsPartyDetails", request).pipe(map(({ body }) => {
            if (!(body instanceof GetLogisticsPartyDetailsOutput)) {
                throw new TypeError(`[CarrierLogisticsWebServer] Expected response body to be of type GetLogisticsPartyDetailsOutput. Got ${body && body.constructor.name}`);
            }
            return body;
        }), catchError((error) => throwError(typeof error === "object" &&
            error !== null &&
            error.constructor.name === CoralResponse.name &&
            error.body !== undefined
            ? error.body
            : error)));
    }
    /**
     * <p>API responsible for getting presigned urls for downloading manuals<\/p>
     **/
    getTermManual(request) {
        return super.call("GetTermManual", request).pipe(map(({ body }) => {
            if (!(body instanceof GetTermManualOutput)) {
                throw new TypeError(`[CarrierLogisticsWebServer] Expected response body to be of type GetTermManualOutput. Got ${body && body.constructor.name}`);
            }
            return body;
        }), catchError((error) => throwError(typeof error === "object" &&
            error !== null &&
            error.constructor.name === CoralResponse.name &&
            error.body !== undefined
            ? error.body
            : error)));
    }
    /**
     * <p>API responsible to submitFeedback<\/p>
     **/
    submitFeedback(request) {
        return super.call("SubmitFeedback", request).pipe(map(() => undefined), catchError((error) => throwError(typeof error === "object" &&
            error !== null &&
            error.constructor.name === CoralResponse.name &&
            error.body !== undefined
            ? error.body
            : error)));
    }
}
CarrierLogisticsWebServer.assembly = "com.amazon.carrierlogisticswebserver.model";
CarrierLogisticsWebServer.serviceName = "CarrierLogisticsWebServer";
